import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-header-second-panel',
  templateUrl: './shared-header-second-panel.component.html',
  styleUrl: './shared-header-second-panel.component.scss',
  standalone: false,
})
export class SharedHeaderSecondPanelComponent {}
